import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
} from "../../../common/component/Index";
import DEFINE, { PATHS } from "../../../../../constants/Define";
import { Descriptions, Card, Icon, Popover } from 'antd';
import { find, cloneDeep, isEqual, findIndex } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Wrapper from './../../../common/component/Wrapper';
import Button from './../../../common/component/Button';
import Input from './../../../common/component/Input';
import EditableText from './../../../common/component/EditableText';

import ExchangeRate from '../../../../../models/ExchangeRate';

import './ExchangeRates.less';
import Modal from '../../../common/component/Modal';

let permissionActions = {};
const defaultState = {
    validation: {},
};

export default class PriceMakeupFlight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            exchangeRate: undefined,
            exchangeRates: [],
        };
    }

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.EXCHANGE_RATE);
        this.initDetail()
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.generalState.exchangeRates, this.props.generalState.exchangeRates)) {
            this.setState({ exchangeRates: cloneDeep(nextProps.generalState.exchangeRates) })
        }
    }

    render() {
        const { t, generalState } = this.props;
        const { isFetching } = generalState;
        const { exchangeRate, exchangeRates } = this.state;

        return (
            <LoadingComponent spinning={isFetching}>
                <PageListComponent className="exchange-rates">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'exchangeRate'}
                        titleHeader={Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.exchangeRate.title')}`.toLowerCase()))}
                    />
                    <Card className='col-md-6 p-3 m-0'>
                        <Descriptions
                            title={`${t(`item.exchangeRate.title`)} ${t(`item.exchangeRate.exchangeRateTo`).toLowerCase()} ${t(`item.exchangeRate.currencies.VND`)}:`}
                        >
                            {exchangeRates.map((rate, index) => {
                                // rate = exchangeRate && rate.id === exchangeRate.id ? exchangeRate : rate;
                                let rateValue = (1 / rate.ratio);
                                if (rateValue % 1 > 0) {
                                    rateValue = rateValue.toFixed(2)
                                }
                                return <Descriptions.Item key={rate.targetCurrency}
                                    label={
                                        <Popover
                                            overlayClassName="max-width-500"
                                            title={`${t(`item.exchangeRate.title`)} ${rate.targetCurrency} - ${rate.sourceCurrency}`}
                                            content={`1 ${rate.targetCurrency} = ${Func.formatMoney(rateValue, false)} ${rate.sourceCurrency}`}
                                        >
                                            {t(`item.exchangeRate.currencies.${rate.targetCurrency}`)}
                                        </Popover>
                                    }
                                >
                                    <Input type="currency"
                                        className="exchange-rate-value"
                                        value={rateValue}
                                        disabled={isFetching}
                                        prefix={isFetching && <Icon type="loading" />}
                                        onFocus={() => this.setState({ exchangeRate: cloneDeep(rate) })}
                                        onChange={e => this.onChangeRatio(rate, index, 1 / Number(e.target.value))}
                                        suffix={t(`item.exchangeRate.currencySymbols.${rate.sourceCurrency}`)}
                                    />
                                    {/* <EditableText
                                        className="exchange-rate-value"
                                        type="currency"
                                        value={rateValue}
                                        prefix={loading}
                                        onFocus={() => this.setState({ exchangeRate: cloneDeep(rate) })}
                                        onChange={e => this.onChange('ratio', 1 / Number(e.target.value))}
                                        onSave={this.onSaveExchangeRate}
                                        suffix={t(`item.exchangeRate.currencySymbols.${rate.sourceCurrency}`)}
                                    /> */}
                                </Descriptions.Item>
                            })}
                        </Descriptions>
                        <Wrapper className="w100-percent text-right">
                            <Button icon="save"
                                disabled={!this.isChangedRates()}
                                onClick={this.onSave}
                                type="primary">{t(`action.save`)}</Button>
                        </Wrapper>
                    </Card>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        this.setState({ exchangeRates: cloneDeep(this.props.generalState.exchangeRates) })
        this.props.getExchangeRates();
    }

    onChange = (fieldName, value) => {
        const { exchangeRate } = this.state;
        exchangeRate[fieldName] = value;
        this.setState({ exchangeRate })
    }

    onChangeRatio = (rate, index, value) => {
        const { exchangeRates } = this.state;
        exchangeRates[index].ratio = value;
        this.setState({ exchangeRates })
    }

    onSaveExchangeRate = () => {
        const { exchangeRate, exchangeRates } = this.state;
        const originalRateIndex = exchangeRate && findIndex(exchangeRates, item => item.id === exchangeRate.id);
        const originalRate = originalRateIndex >= 0 ? exchangeRates[originalRateIndex] : undefined;
        if (originalRate && originalRate.ratio === exchangeRate.ratio) return;
        originalRate.ratio = exchangeRate.ratio;
        exchangeRates[originalRateIndex] = exchangeRate;
        this.setState({ exchangeRate: new ExchangeRate(), exchangeRates });
        return true
    }

    isChangedRates = () => {
        const { exchangeRates } = this.state;
        const originalRates = this.props.generalState.exchangeRates;
        return !isEqual(exchangeRates, originalRates);
    }

    onSave = () => {
        const { t } = this.props;
        const { confirm } = Modal;
        if (!this.isChangedRates()) return
        confirm({
            title: t('action.save') + ' ' + t(`item.exchangeRate.title`).toLowerCase() + ' ' + t(`item.exchangeRate.currencies.VND`),
            okText: t(`action.save`),
            cancelText: t(`action.cancel`),
            onOk: this.updateExchangeRate,
        });
    }

    updateExchangeRate = () => {
        const { exchangeRates } = this.state;
        const originalRates = this.props.generalState.exchangeRates;
        exchangeRates.forEach(rate => {
            const originalRate = find(originalRates, item => item.id === rate.id);
            if (originalRate.ratio !== rate.ratio) {
                this.props.updateExchangeRate(rate);
            }
        })
    }

}
